import { parseLocalYmd } from "@/utils/localDate";
import { getAuthEntities } from "@/api/information.js";
import GOOGLE from "@/assets/img/image9.svg"
import TRIPADVISOR from "@/assets/img/Group1000002834.svg"
import OpenTable from "@/assets/img/OpenTable.png";
import Yelp from "@/assets/platforms/yelp.png";
import WONGNAI from "@/assets/platforms/wongnai.png";
import { filterBySources } from "@/utils/menuSources";

export default {
    namespaced: true,
    state: {
        restaurantList: [],
        ratingArr:[
            {
                name: "Google", // 页面显示带.com
                value: "Google", // 传递用全大写
                icon: GOOGLE,
                selected:true
            },
            {
                name: "Tripadvisor", // 页面显示带.com
                value: "Tripadvisor", // 传递用全大写
                icon: TRIPADVISOR,
                selected:true
            },
            {
                name: "Wongnai",
                value: "Wongnai", // togglePlatform 传递时会 .toUpperCase()
                icon: WONGNAI,
                selected:true
            },
            // OpenTable / Yelp 是此前刻意注释掉的（产品决定不在这个选择器里出现），保持原样。
            // {
            //     name: "OpenTable",
            //     value: "OpenTable", // togglePlatform 传递时会 .toUpperCase()
            //     icon: OpenTable,
            //     selected:true
            // },
            // {
            //     name: "Yelp",
            //     value: "Yelp",
            //     icon: Yelp,
            //     selected:true
            // },
        ],
        // 运行时会被 App.vue mounted 的 SET_selectedPlatforms 覆盖为全大写；此处保持大写与之一致
        selectedPlatforms:['GOOGLE', 'TRIPADVISOR', 'OPENTABLE', 'YELP', 'WONGNAI'],
        dateRange: {
            start: null, // 存储格式：'YYYY-MM-DD' 字符串
            end: null,
        },
        CurrentRangeType: null,
        selectedRestaurantId:"",
        ReviewShowType: true,
    },
    mutations: {
        change_ReviewShowType(state, showType) {
            state.ReviewShowType = showType;
        },
        SET_RESTAURANT_LIST(state, list) {
            state.restaurantList = list;
        },
        SET_selectedRestaurantId(state,data){
            state.selectedRestaurantId = data;
        },
        // 设置评分信息
        SET_RATING_INFOS(state, payload) {
            state.ratingArr = payload;
        },
        // 设置评分信息
        SET_selectedPlatforms(state, payload) {
            state.selectedPlatforms = payload;
        },
        SET_DATE_RANGE(state, { start, end }) {
            // 强制存储为字符串格式，避免Date对象序列化问题
            state.dateRange = {
                start: typeof start === "string" ? start : null,
                end: typeof end === "string" ? end : null,
            };
            console.log(`[Vuex] 日期范围更新: ${start} 至 ${end}`);
        },
        SET_SELECTED_PLATFORMS(state, platforms) {
            // 平台名统一处理：去重 + 首字母大写
            const lowerUniquePlatforms = [
                ...new Set(platforms.map((p) => p.toLowerCase().trim())),
            ];
            const capitalizedPlatforms = lowerUniquePlatforms.map((platform) => {
                if (!platform) return "";
                return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
            });
            state.selectedPlatforms = capitalizedPlatforms;
            console.log(`【Vuex更新】选中平台: ${capitalizedPlatforms.join(", ")}`);
        },
        changeCurrentRange(state, newRange) {
            state.CurrentRangeType = newRange;
        },
    },
    actions: {
        updateSelectedPlatforms({ commit }, platforms) {
            commit("SET_SELECTED_PLATFORMS", platforms);
        },
        loadRatingInfos({ commit },ratings) {
            commit('SET_RATING_INFOS', ratings);
        },
        updateDateRange({ commit }, dateRange) {
            if (!Array.isArray(dateRange) || dateRange.length !== 2) {
                console.error("日期范围格式错误，必须为 [start, end] 数组");
                return;
            }

            // 改进的日期格式化方法，确保日期计算正确
            const formatDate = (date) => {
                if (!date) return null;

                let d;
                if (date instanceof Date) {
                    d = new Date(date); // 复制日期对象避免修改原对象
                } else if (typeof date === "number") {
                    d = new Date(date);
                } else if (typeof date === "string") {
                    // WTK-815：'YYYY-MM-DD' 按本地零点解析（new Date 会当成 UTC 零点，美洲时区会早一天）
                    d = parseLocalYmd(date);
                } else {
                    console.warn("无效日期格式，已忽略:", date);
                    return null;
                }

                // 关键修复：添加时区偏移量，避免本地时间转UTC时日期减少一天
                const offset = d.getTimezoneOffset();
                d = new Date(d.getTime() - offset * 60 * 1000);

                const year = d.getUTCFullYear();
                const month = String(d.getUTCMonth() + 1).padStart(2, "0");
                const day = String(d.getUTCDate()).padStart(2, "0");

                return `${year}-${month}-${day}`;
            };

            const start = formatDate(dateRange[0]);
            const end = formatDate(dateRange[1]);

            if (start && end) {
                commit("SET_DATE_RANGE", { start, end });
            } else {
                console.warn("日期范围不完整，未更新状态");
            }
        },
    },
    getters : {
        dateRange: (state) => state.dateRange,
        // 当前选中的餐厅（对齐 hotel.js 的 currentHotel getter）
        currentRestaurant: (state) => state.restaurantList.find(
            (restaurant) => restaurant.restaurantId === state.selectedRestaurantId
        ),
        // 按当前餐厅 menu.sources 白名单过滤后的平台选择器列表
        visibleRatingArr: (state, getters) => {
            const sources = getters.currentRestaurant ? getters.currentRestaurant.menu && getters.currentRestaurant.menu.sources : null;
            return filterBySources(state.ratingArr, sources, (item) => item && item.value);
        },
    },
};
